<template>
  <h3>Condiciones lógicas</h3>
  <p>Añada condiciones lógicas a su formulario</p>

  <a-button class="button" @click="emit('click:add')">
    <PlusOutlined />
    Agregar condición lógica
  </a-button>

  <template v-if="conditions.length !== 0">
    <a-divider class="divider" type="horizontal" />

    <div class="list">
      <FormConditionCard
        v-for="condition in conditions"
        :key="condition.id"
        :condition="condition"
        @edit="(id) => emit('edit', id)"
        @delete="(id) => emit('delete', id)"
      />
    </div>
  </template>
</template>

<script setup lang="ts">
import { PlusOutlined } from "@ant-design/icons-vue";

import { Condition } from "@/@types/entities/forms";
import FormConditionCard from "@/app/entities/components/card/FormConditionCard.vue";

defineProps<{
  conditions: Condition[];
}>();

const emit = defineEmits<{
  (e: "click:add"): void;
  (e: "edit", id: string): void;
  (e: "delete", id: string): void;
}>();
</script>

<style scoped lang="sass">
h3
  font-size: 24px
  font-weight: 600
  color: $gray-8
  margin: 0

p
  color: $gray-8
  margin-bottom: 12px

.button
  color: $gray-8
  width: 100%

.list
  display: grid
  gap: 16px
  max-height: calc(100vh - 370px)
  overflow: auto

.divider
  background-color: $geekblue-6
  margin: 20px 0
</style>
